<template>
    <ECharts ref="chart" :option="calculateOptions()" style="height: 500px" />
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import { plugin } from "echarts-for-vue";
import * as echarts from "echarts";

Vue.use(plugin, { echarts });
export default {
    name: "PieChart",
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        calculateOptions() {
            const data = this.data;
            if (!data) return {};
            const result = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: 10,
                    data: data.map((item) => item.legend),
                },
                color: data.map((item) => item.color),
                series: [
                    {
                        name: "Data",
                        type: "pie",
                        radius: "50%",
                        data: data
                            // .filter((x) => x.value > 0)
                            .map((item) => ({
                                value: item.value,
                                name: item.label,
                            })),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };

            return result;
        },
    },
};
</script>

<style scoped></style>
